module.exports = __webpack_public_path__ + "static/media/coral-3.a712a18a.png";